<div class="d-flex flex-row flex-auto kpi-report" *ngIf="kpiReports">
  <div class="exposure-kpi-item" *ngFor="let kpi of kpiReports">
    <achoo-kpi-report-item [kpiLabel]="kpi.name"
                           [kpiValue]="kpi.value"
                           [kpiStatus]="kpi.status"
                           [kpiPercent]="kpi.percent"
                           [kpiDescription]="kpi.description" >
    </achoo-kpi-report-item>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/measure/exposure-kpi-report/exposure-kpi-report.component.html